import { AnyColor, Colord as NativeColored } from 'colord'
import { lightenRelative } from './utils'

// Hoping to merge this into the native library:
// https://github.com/omgovich/colord/issues/90
class ExtendedColord extends NativeColored {
  public lightenRelative(amount: number = 0.1) {
    return extendedColord(lightenRelative(this.rgba, amount))
  }

  public darkenRelative(amount: number = 0.1) {
    return extendedColord(lightenRelative(this.rgba, -amount))
  }
}

export const extendedColord = (input: AnyColor | NativeColored): ExtendedColord => {
  if (input instanceof ExtendedColord) return input
  return new ExtendedColord(input as any)
}
